var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CheckboxGroup',{attrs:{"label":_vm.answer.name,"checked":_vm.answerModel},model:{value:(_vm.answerModel),callback:function ($$v) {_vm.answerModel=$$v},expression:"answerModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }